// src/services/sizeSpecGarmentTypeApi.js
// CRUD para tabla de medidas (sizeSpec) y tipos de prenda (garmentType)

import { dotoniwoofApi } from '../api/dotoniwooApi';

const SIZE_SPEC_BASE = '/sizeSpec.php';
const GARMENT_TYPE_BASE = '/garmentType.php';

const apiResult = (response) => ({
  ok: true,
  status: response.status,
  data: response.data
});

const apiError = (error) => ({
  ok: false,
  status: error.response?.status || 500,
  data: error.response?.data || { message: 'Error de conexión' }
});

// ============ SIZE SPEC (Tabla de medidas) ============

export const getSizeSpecs = async (sizeCode = null) => {
  try {
    const params = sizeCode ? { size_code: sizeCode } : {};
    const response = await dotoniwoofApi.get(SIZE_SPEC_BASE, { params });
    return apiResult(response);
  } catch (error) {
    console.error('Error al obtener tallas:', error);
    return apiError(error);
  }
};

export const createSizeSpec = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(SIZE_SPEC_BASE, payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al crear talla:', error);
    return apiError(error);
  }
};

export const updateSizeSpec = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${SIZE_SPEC_BASE}/${id}`, payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al actualizar talla:', error);
    return apiError(error);
  }
};

export const deleteSizeSpec = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`${SIZE_SPEC_BASE}/${id}`);
    return apiResult(response);
  } catch (error) {
    console.error('Error al eliminar talla:', error);
    return apiError(error);
  }
};

// ============ GARMENT TYPE (Tipos de prenda) ============

export const getGarmentTypes = async () => {
  try {
    const response = await dotoniwoofApi.get(GARMENT_TYPE_BASE);
    return apiResult(response);
  } catch (error) {
    console.error('Error al obtener tipos de prenda:', error);
    return apiError(error);
  }
};

export const createGarmentType = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(GARMENT_TYPE_BASE, payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al crear tipo de prenda:', error);
    return apiError(error);
  }
};

export const updateGarmentType = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${GARMENT_TYPE_BASE}/${id}`, payload);
    return apiResult(response);
  } catch (error) {
    console.error('Error al actualizar tipo de prenda:', error);
    return apiError(error);
  }
};

export const deleteGarmentType = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`${GARMENT_TYPE_BASE}/${id}`);
    return apiResult(response);
  } catch (error) {
    console.error('Error al eliminar tipo de prenda:', error);
    return apiError(error);
  }
};
